<script setup lang="ts">
import { T } from '@tolgee/vue'
import BalanceCurrencyImage from '@/assets/images/dropee-token-new.webp'
import { computed } from 'vue'
import { formatNumberFullTruncate } from '@/helpers/utils'
import CrossCircleIcon from '@/components/icons/CrossCircleIcon.vue'
import WithdrawInfo from '@/components/WithdrawInfo.vue'
import { useWatchOverlays } from '@/composables/helpers/scoll'
import { useFullScreenDimensions } from '@/composables/helpers/fullscreen'

const props = defineProps<{
  show: boolean
  amount: number,
  walletAdress: string
}>()

const { topStyle } = useFullScreenDimensions()
useWatchOverlays(computed(() => props.show))
</script>
<template>
  <div
    class="fixed h-screen max-h-dvh w-screen overflow-hidden left-0 bottom-0 transition-all duration-300 bg-dark-most-bottom-layer/[.95] flex flex-col"
  >
    <CrossCircleIcon
      class="w-6 h-6 min-w-[24px] absolute top-3 right-3 text-white/[87%]"
      :style="topStyle"
    />
    <div class="h-full w-full flex-1 flex flex-col">
      <div class="p-8 max-[390px]:px-3 h-full w-full flex flex-col items-center justify-center">
        <div class="w-full items-center flex flex-col flex-1 gap-y-6 justify-center">
          <div class="text-[36px] font-semibold leading-[42px] z-[10] uppercase text-center">
            <T
              key-name="balance.withdraw.overlay.title"
              default-value="Balance withdrawn"
            />
          </div>
          <div
            class="w-[212px] min-w-[212px] h-[212px] relative border-2 border-[#E8FFBA] rounded-full bg-black/[.12] backdrop-blur-[16px]"
          >
            <div
              class="w-[120%] h-[120%] absolute -top-[10%] -left-[10%] rounded-full bg-teal-primary blur-[122px]"
            />
            <img
              class="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 w-[132px] h-[132px] min-w-[132px] rounded-full"
              :src="BalanceCurrencyImage"
            >
          </div>
          <p
            class="text-base text-center text-light-white z-[10] font-medium max-w-[315px] -tracking-[0.32px] whitespace-pre-line"
          >
            <T
              key-name="balance.withdraw.overlay.description"
              default-value="Your withdrawal of {amount} $DROPEE is being processed."
              :params="{ amount: formatNumberFullTruncate(amount, true)}"
            />
          </p>
          <WithdrawInfo
            :wallett-address="walletAdress"
            class="z-[10]"
          />
        </div>
      </div>
    </div>
  </div>
</template>